export type ContactMethod = 'whatsapp' | 'telegram'

export interface StepAboutYouData {
	firstName: string
	lastName: string
	email: string
	contactMethods: ContactMethod[]
	whatsappCountryCode: string
	whatsappNumber: string
	telegramUsername: string
	termsAccepted: boolean
}

export interface StepAboutBusinessData {
	siteLive: boolean
	monthlyVolume: string
	needsProcessing: boolean
	currentProcessors: string[]
	platforms: string[]
	websiteUrl: string
}

export interface StepCreateAccountData {
	accountName: string
	/** Referral code (`TGD-XXXXXX`), prefilled from `?ref=` when the visitor arrived with one. */
	referralCode?: string
}

export interface SignUpFormData {
	aboutYou: StepAboutYouData
	aboutBusiness: StepAboutBusinessData
	createAccount: StepCreateAccountData
}

export type WizardStep = 1 | 2 | 3 | 'otp'

export const DEFAULT_ABOUT_YOU: StepAboutYouData = {
	firstName: '',
	lastName: '',
	email: '',
	contactMethods: [],
	whatsappCountryCode: 'US',
	whatsappNumber: '',
	telegramUsername: '',
	termsAccepted: false,
}

export const DEFAULT_ABOUT_BUSINESS: StepAboutBusinessData = {
	siteLive: false,
	monthlyVolume: '',
	needsProcessing: false,
	currentProcessors: [],
	platforms: [],
	websiteUrl: '',
}

export const DEFAULT_CREATE_ACCOUNT: StepCreateAccountData = {
	accountName: '',
}

export const DEFAULT_FORM_DATA: SignUpFormData = {
	aboutYou: DEFAULT_ABOUT_YOU,
	aboutBusiness: DEFAULT_ABOUT_BUSINESS,
	createAccount: DEFAULT_CREATE_ACCOUNT,
}
